module.exports = __webpack_public_path__ + "static/media/trimex_medalladeoro_c1frances.2e8110bf.png";